import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Alle Pipedrive-Aufrufe laufen über unseren Server (/api/pipedrive/*),
// der den API-Token anhängt. Der Token darf nie im Frontend-Bundle landen.
export const PIPEDRIVE_PROXY_URL = `${API_URL}/pipedrive`;

const authHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const pipedriveClient = axios.create({ baseURL: PIPEDRIVE_PROXY_URL });

pipedriveClient.interceptors.request.use((config) => {
  Object.assign(config.headers, authHeader());
  return config;
});

// fetch-Variante für Stellen, die mit Response-Objekten arbeiten
export const pipedriveFetch = (path, options = {}) =>
  fetch(`${PIPEDRIVE_PROXY_URL}${path}`, {
    ...options,
    headers: { ...options.headers, ...authHeader() },
  });

export default pipedriveClient;
